import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../App.css';

class AppInfo extends Component {

    constructor(props){
        super()
    }

    render() {
        return (
            <div className="app-info-container">
                <button className="close-button" onClick={this.props.closeContainer}><img className="close-button" alt="" src={require('../images/cross.svg')}/></button>
                <div className="app-info-details">
                    <div className="app-info-title">{this.props.appName}</div>
                    <div className="app-info-detail">{this.props.appDetail}</div>
                </div>
                <div className="app-info-link-container">
                    <a href={this.props.appLink} target="_blank">
                        <img className="app-store-image" alt="" src={require('../images/app-store.svg')}></img>
                    </a>
                </div>
            </div>
        );
    }
}

AppInfo.propTypes = {
    appName: PropTypes.string,
    appDetail: PropTypes.string,
    appLink: PropTypes.string,
    closeContainer: PropTypes.func
};


export default AppInfo;


// WEBPACK FOOTER //
// ./src/components/AppInfo.js